/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');
require('components/common/table-data/table-data');
require('components/common/search-tool/search-tool');
require('components/base/input-box/input-box');
require('components/base/btn/btn');
require('components/base/loading/loading');
require('./used-car-list.scss');
require('components/common/date-time/date-time')
const { time } = require('src/common/utils/date');
const ajax = require('appUtil/ajaxHttp');
const { apiPath } = require('appService/api');
const tip = require('components/base/pop/tip');
const template = require('./used-car-list.tpl');

const usedCarList = {
	name: "usedCarList",

	template,

	data() {
    return {
      carStatus: 0,
      dateConfig:{ format: 'yyyy-mm-dd',minView: 'month'},
    	markSaledId: "",
    	optionsWord: "是否隐藏？",
    	thItems: ["序号", "用户手机号", "用户所在地", "帖子标题", "发布时间", "售价", "车辆状态", "帖子状态", "操作"],
      url: apiPath.usedCar.usedCarList + "?_size=10",
      thLength: 9,
      curParams: {
      	curId: "",
      	visible: ""
      },
      queryParams: {},
      fetchQuery: ({ queryOpt }) => {
        this.queryParams = {
          "brandId": queryOpt["brandId"] ? queryOpt['brandId'].value : null,
          "keyword": queryOpt["keyword"] ? queryOpt["keyword"] : null,
          "startTime": queryOpt.startTime,
          "endTime": queryOpt.endTime,
        }
        this.$refs.tableData.query(this.queryParams).fetch();
      },
      startTimeInput: "",
      endTimeInput: "",
      carDropMenuUrl: apiPath.usedCar.allUsedCarList,
      exportUrl: apiPath.usedCar.derive,
      token: ""
    }
	},
	methods: {
    checkout(url){
      window.open(url);
    },
    tabChange(cur){
      this.carStatus = cur;
      let params ={
        carStatus: this.carStatus
      }
      params = Object.assign({}, params, this.queryParams);
      this.$refs.tableData.query(params).fetch()
    },
    getDate(val){
      if (val){
        let dTime = new Date();
        let now = time(new Date().getTime())
        this.endTimeInput = this.getFormDate(now);
        this.startTimeInput = this.getFormDate(dTime.setDate(dTime.getDate() - parseInt(val)));
      }
      let params = {
        startTime: this.startTimeInput,
        endTime: this.endTimeInput
      }
      params = Object.assign({}, this.queryParams, params);
      this.$refs.tableData.query(params).fetch();
    },
    exportOption(){
      let params = {
        // size: this.$refs.tableData.pageItems.size,
        // current: this.$refs.tableData.pageItems.current,
        startTime: this.startTimeInput,
        endTime: this.endTimeInput,
        carStatus: this.carStatus,
        keyword: "",
        brandId: 0
      }
      params = Object.assign({}, params, this.queryParams);
      // window.open(`${this.exportUrl}?token=${this.token}&brandId=${params.brandId}&startTime=${params.startTime}&endTime=${params.endTime}&carStatus=${params.carStatus}&keyword=${params.keyword}`);
      window.open(`${this.exportUrl}?brandId=${params.brandId}&startTime=${params.startTime}&endTime=${params.endTime}&carStatus=${params.carStatus}&keyword=${params.keyword}`);
    },
    getFormDate(time, hasNoHM){
      let dTime = new Date(time),
      dMinutes = dTime.getMinutes();
      dMinutes = dMinutes< 10 ? "0"+ dMinutes : dMinutes;
      return ( hasNoHM ? `${dTime.getFullYear()}-${dTime.getMonth()+1}-${dTime.getDate()}  ${dTime.getHours()}:${dMinutes}` : `${dTime.getFullYear()}-${dTime.getMonth()+1}-${dTime.getDate()}`);
    },
		markSaled(curId){
			this.markSaledId = curId
			this.$refs.markSaled.show()
		},
		markSaledCb(){
			ajax(apiPath.usedCar.markSaled,{
				data: {
					curId: this.markSaledId
				},
				type: 'POST'
			}).then((res)=>{
				this.$refs.markSaled.hide()
				tip('设置成功！')
				this.$refs.tableData.fetch()
			})
		},
		hideOrShow(curId, visible){
			this.$set('curParams.curId', curId)
      if(visible == 1){
        this.$set('curParams.visible', 2)
      }else{
        this.$set('curParams.visible', 1)
      }
			this.optionsWord = visible == 1 ? '是否隐藏？' : '是否显示？'
			this.$refs.hideOrShow.show()
		},
		hideOrShowCb(){
			ajax(apiPath.usedCar.hideOrShow,{
				data: this.curParams,
				type: 'POST'
			}).then((res)=>{
				this.$refs.hideOrShow.hide()
				tip('设置成功！')
				this.$refs.tableData.fetch()
			})
		}
	}
}

module.exports = usedCarList;




// WEBPACK FOOTER //
// ./src/appBackend/components/page/usedCar/used-car-list/used-car-list.js